// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"b96cba4b","113":"610e23a1","142":"a2c28b54","318":"6da2a638","355":"7354a123","438":"af552cfb","538":"50dc7a1b","648":"92503f0f"}[chunkId] + ".chunk.js";
};